import React from 'react'
import { t } from '../translation/Translation'
import SpinnerWrapper from 'components/common/atoms/SpinnerWrapper'
import { useNavigate } from 'react-router-dom'
import RightArrow from 'static/images/RightArrow'
import Pagination from "components/common/atoms/Pagination";
import ResetBtn from 'components/common/atoms/ResetBtn'
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { formData } from './TodosOverview'
import { OptionProps } from 'components/common/utlis/TypeAnnotations'
import SelectWithSearch from 'components/common/atoms/SelectWithSearch'
import Button from 'components/common/atoms/Button'
import EncryptDecryptService from 'components/common/services/EncryptDecryptService'
import { Number } from 'aws-sdk/clients/iot'
import { useSelector } from 'react-redux'
import { selectAuth } from 'features/auth/AuthSlice'
import { RECRUITER } from 'Constants'


export interface ReportItem {
    office: string;
    officeId: string | number;
    entityName: string;
    entityType: string | Number;
    entityId: string;
    // userId: string | number;
    role: string;
    fromDate: string;
    toDate: string;
    link: string;
    year: string | number;
    monthNumber: string | number;
}

export interface ReportTodosProps {
    loading: boolean;
    reports: ReportItem[];
    totalPages: number;
    currentPage: number;
    handlePageChange: (page: number) => void;
}

export interface ReportTodosSearchProps {
    handleReset: () => void;
    handleSearch: (e: React.FormEvent) => void;
    formData: formData;
    dropDownData: {
        office: OptionProps[];
        user: OptionProps[];
    };
    handleSelectChange: (selectedOption: OptionProps[] | null, fieldName: string) => void;
}

const ReportTodos: React.FC<ReportTodosProps> = ({
    loading,
    reports,
    totalPages,
    currentPage,
    handlePageChange,
}) => {
    const navigate = useNavigate();

    const handleButton = (item: any, link: string) => {
        navigate(`${link}?data=${encodeURIComponent(EncryptDecryptService.encryptData(JSON.stringify(item)))}`)
    }
    return (
        <>
            <div className="table-responsive tableSection">
                <div className="myTodosTableWrapper scrollBarDesign">
                    <table className="table table-hover">
                        <thead>
                            <tr className="TableHeader">
                                <th className="ps-lg-4">{t("Office")}</th>
                                <th>{t("User")}</th>
                                <th>{t("Role")}</th>
                                <th>{t("Month")}</th>
                                <th>{t("Action")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <SpinnerWrapper headerLength={5} />
                            ) : reports.length === 0 ? (
                                <tr className="border rounded-3">
                                    <td
                                        colSpan={7}
                                        className="border-0 text-center py-3 no-records"
                                    >
                                        <span className="text-danger w-100 d-block text-center">
                                            {t("No tasks")}
                                        </span>
                                    </td>
                                </tr>
                            ) : (
                                reports.map((report, index) => {
                                    const user = {
                                        officeId: report.officeId,
                                        ...(report.entityType == 2
                                            ? { recruiterId: report.entityId }
                                            : { omId: report.entityId }),
                                        periodNumber: report.monthNumber,
                                        year: report.year,
                                    };
                                    return (
                                        <tr
                                            key={index}
                                            className="border-bottom mb-3 box-shadow align-middle"
                                        >
                                            <td className="ps-lg-4">{report.office}</td>
                                            <td>{report.entityName}</td>
                                            <td>{report.role}</td>
                                            <td>{report.fromDate} {t("to")} {report.toDate}</td>
                                            <td>
                                                <td className="table-action-icons">
                                                    <span
                                                        className="border-0 me-2"
                                                        onClick={() => handleButton(user, report.link)}>
                                                        <RightArrow />
                                                    </span>
                                                </td>
                                            </td>
                                        </tr>
                                    )
                                })
                            )}
                        </tbody>
                    </table>
                </div>
                {totalPages > 1 &&
                    <div className="pagination justify-content-center align-items-center">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={(newPage) => handlePageChange(newPage)}
                        />
                    </div>
                }
            </div>
        </>
    );
};

export default ReportTodos;


export const ReportTodosSearch: React.FC<ReportTodosSearchProps> = ({
    handleReset,
    handleSearch,
    formData,
    dropDownData,
    handleSelectChange,
}) => {

    const userAuth = useSelector(selectAuth);

    const getDefaultOffice = () => {
        const values = { value: userAuth.officeId, label: userAuth.office };
        return values;
    }
    return (
        <>
            <div className="d-grid grid-5" style={{ paddingTop: "1vw" }}>
                <div>
                    <SelectWithSearch
                        search={true}
                        options={dropDownData.office}
                        title={t("Office")}
                        onChange={(e) => handleSelectChange(e, "office")}
                        isMulti={true}
                        name="office"
                        value={userAuth.role == RECRUITER ? getDefaultOffice() : formData.office}
                        isTranslate={true}
                        isDisabled={userAuth.role == RECRUITER}
                    />
                </div>
                {userAuth.role !== RECRUITER &&
                    <div>
                        <SelectWithSearch
                            search={true}
                            options={dropDownData?.user}
                            title={t("User")}
                            onChange={(e) => handleSelectChange(e, "user")}
                            isMulti={true}
                            name="user"
                            value={formData.user}
                            isTranslate={true}
                        />
                    </div>
                }
                {userAuth.role !== RECRUITER &&
                    <div className="text-end mt-34">
                        <div className="d-flex align-items-center">
                            <ResetBtn handleResetClick={handleReset} />
                            <Button
                                title={t("Search")}
                                type="submit"
                                icon={faMagnifyingGlass}
                                handleClick={handleSearch}
                                className="form-button shadow-none search-btns text-start position-relative"
                            />
                        </div>
                    </div>
                }
            </div>

        </>
    );
};



